import * as React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import get from 'lodash.get';
import Image from 'rc-image';

import LoadingComponent from '../core/LoadingComponent';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
            style={{ width: '100%' }}
        >
            {value === index && (
                <Box sx={{ p: 3, width: '100%' }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

export default function VerticalTabs({ id, files }) {

    const getClaimDocuments = (id) => {
        axios({
            url: `/document/list/${id}`,
            baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/su/support`,
            method: "GET",
            headers: {
                "X-Client-Platform": "CLAIM-ENHANCEMENT",
                "Content-Type": "blob",
                "X-Auth-Token": `${localStorage.getItem("authToken")}`,
            },
        })
            .then((response) => {
                setDocuments(get(response, ['data'], []))
            })
            .catch((error) => {
                console(error.message);
            });
    }

    const [documents, setDocuments] = React.useState([]);
    const [fileIndex, setFileIndex] = React.useState(0)
    const [isLoading, setIsLoading] = React.useState(true)

    React.useEffect(() => {
        if (files.length > 0) {
            setDocuments(files)
        }
        getClaimDocuments(id)
        setIsLoading(false)
    }, [])


    function getMimeTypeFromBase64(base64String) {
        // Extract the first few bytes from the base64 string
        var bytes = atob(base64String).slice(0, 4);

        // Convert bytes to hexadecimal representation
        var hex = '';
        for (var i = 0; i < bytes.length; i++) {
            hex += ('00' + bytes.charCodeAt(i).toString(16)).slice(-2);
        }

        // Determine the MIME type based on the hexadecimal representation
        switch (hex) {
            case '89504e47':
                return 'image';
            case '47494638':
                return 'image';
            case '25504446':
                return 'pdf';
            case 'ffd8ffe0':
            case 'ffd8ffe1':
            case 'ffd8ffe2':
            case 'ffd8ffe3':
            case 'ffd8ffe8':
                return 'image';
            // Add more cases as needed for other file types
            default:
                return 'unknown';
        }
    }

    const handleChange = (event, newValue) => {
        setFileIndex(newValue);
    };

    const handleDownloadClick = (url, filename) => {
        // Create a link element
        window.open(url)
    }

    if (isLoading) {
        return <LoadingComponent />
    }

    if (documents.length === 0) {
        return <Grid style={{ textAlign: "center", marginTop: '3.5rem' }}>
            <p>
                No Document is present for this claim
            </p>
        </Grid>
    }

    return (
        <Box
            sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: '1000px' }}
        >
            <Tabs
                orientation="vertical"
                variant="scrollable"
                value={fileIndex}
                onChange={handleChange}
                sx={{
                    borderRight: 1,
                    borderColor: 'divider'
                }}
            >
                {
                    documents.map((item, index) => <Tab
                    style={{textOverflow: 'clip'}}
                        key={index}
                        wrapped
                        label={
                            <Tooltip  placement="right-start" title={get(item, ['fileName'], String(index))}>
                                <Typography variant="body2" style={{ width: 'inherit', textOverflow: 'clip' }}>
                                    {get(item, ['fileName'], String(index))}
                                </Typography>
                            </Tooltip>} />
                    )
                }
            </Tabs>
            <TabPanel value={0} index={0}>
                {
                    get(documents, [fileIndex, 'fileName'], '').toLowerCase().includes('.pdf') &&
                    <iframe
                        title="PDF Viewer"
                        src={documents[fileIndex]['preSingedURL']}
                        width='100%'
                        height="975px"
                    />
                }
                {
                    (
                        get(documents, [fileIndex, 'fileName'], '').toLowerCase().includes('.png') ||
                        get(documents, [fileIndex, 'fileName'], '').toLowerCase().includes('.jpg') ||
                        get(documents, [fileIndex, 'fileName'], '').toLowerCase().includes('.jpeg')
                    ) &&
                    <Image src={documents[fileIndex]['preSingedURL']} />
                }
                {
                    !(
                        get(documents, [fileIndex, 'fileName'], '').toLowerCase().includes('.png') ||
                        get(documents, [fileIndex, 'fileName'], '').toLowerCase().includes('.jpg') ||
                        get(documents, [fileIndex, 'fileName'], '').toLowerCase().includes('.jpeg') ||
                        get(documents, [fileIndex, 'fileName'], '').toLowerCase().includes('.pdf')
                    ) &&
                    <Button
                        variant='contained'
                        color="primary"
                        onClick={() => handleDownloadClick(get(documents, [fileIndex, 'preSingedURL'], ''), get(documents, [fileIndex, 'fileName'], ''))}
                    >
                        <span>Download File</span>
                    </Button>
                }
            </TabPanel>
        </Box>
    );
}
